import { createApp } from 'vue/dist/vue.esm-bundler.js';
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import router from './router';

import { createMyVuetify, resolveVuetifyLocale } from './plugins/vuetify';

import Vue3Toastify from 'vue3-toastify';
import { toast } from 'vue3-toastify';
import { createPinia } from 'pinia';
import eCharts from 'vue-echarts';

import 'vue3-toastify/dist/index.css'
import 'unfonts.css'

//#region TRANSLATION
import locales from './components/json/locales.json';

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: locales,
})
//#endregion

import App from './App.vue';

//#region VUETIFY
const userLocaleVuetify = resolveVuetifyLocale(window.navigator.language);
const vuetify = createMyVuetify(userLocaleVuetify);
// #endregion

const pinia = createPinia();

const app = createApp(App)
    .use(router)
    .use(i18n)
    .use(vuetify)
    .use(Vue3Toastify,{autoClose:2500, position:'top-right', theme:'colored'})
    .use(pinia)
    .component('v-chart', eCharts)
    .mount('#app');

// #region EXTENSIONS 

$.extend({
    redirectPost: function (location, args) {
        var form = '';

        $.each(args, function (key, value) {
            value = value.split('"').join('\"');
            form += '<input type="hidden" name="' + key + '" value="' + value + '">';
        });

        $('<form target="_blank" action="' + location + '" method="POST">' + form + '</form>').appendTo($(document.body)).submit();
    },

    postData: async function (url = '', data = {}, xhrFields = null) {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            xhrFields: xhrFields,
        });

        return response.json();
    },

    getData: async function (url = '', data = {}, xhrFields = null) {
        var formBody = [];

        for (var property in data) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(data[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }

        formBody = formBody.join("&");

        const response = await fetch(url, {
            method: 'POST',
            body: formBody,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            xhrFields: xhrFields,
        });

        try {
            if (response.ok) {
                if (response.url.indexOf('GetFile') == -1)
                    return response.json();
                else
                    return response.blob();
            }

            throw new Error('Something went wrong with response.');
        }
        catch (error) {
            console.log(error);
            console.error(response);
        }
    },

    downloadFile: async function (guid, path, fileName, urlWebAPI, customerReference, token, isConfig = false) {
        var data = (guid != null) ? {
            token: token,
            customerReference: customerReference,
            guid: guid,
            isConfig: isConfig,
        } : {
            token: token,
            customerReference: customerReference,
            path: path,
            isConfig: isConfig,
        };

        this.getData(urlWebAPI + 'GetFile', data, { responseType: 'blob' })
            .then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
            })
            .catch(error => {
                console.log(error);
                toast.error('Error during executing GetFile data.');
            });
    },

    uploadFiles: function (files, customerPath, root, isConfig = false, callback = null, callbackParams = null) {
        var data = new FormData();
        for (var i = 0; i != files.length; i++)
            data.append('files', files[i]);

        data.append('customerPath', customerPath);
        data.append('isConfig', isConfig);

        $.ajax({
            url: root.urlWebAPI + 'UploadFiles',
            data: data,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function (files) {
                if (files.length > 0)
                    toast.success(root.translate('filesUploadedSucess', 'toast'))

                if (callback != null)
                    callback(callbackParams);
            }
        });
    },
});

$.fn.extend({
    disable: function () {
        $(this).attr('disabled', 'disabled');

        // MDC CHECKBOX CASE - DISABLE PARENT LIST ITEM
        if ($(this).attr('type') == 'checkbox' && $(this).hasClass('mdc-checkbox__native-control')) {
            var mdcListItem = $(this).parent().parent().parent();

            if (mdcListItem.length > 0 && mdcListItem.hasClass('mdc-list-item'))
                mdcListItem.addClass('disabled');
        }
    },
    enable: function () {
        $(this).removeAttr('disabled').removeClass('mdc-text-field--disabled');

        // MDC SELECT
        try {
            $($(this)[0].root).removeClass('mdc-text-field--disabled');
            $($(this)[0].root).find('input').removeAttr('disabled');
        }
        catch (error) {
            console.log(error);
        }

        // MDC CHECKBOX CASE - DISABLE PARENT LIST ITEM
        if ($(this).attr('type') == 'checkbox' && $(this).hasClass('mdc-checkbox__native-control')) {
            var mdcListItem = $(this).parent().parent().parent();

            if (mdcListItem.length > 0 && mdcListItem.hasClass('mdc-list-item'))
                mdcListItem.removeClass('disabled');
        }
    },
    isDisable: function () {
        return $(this).attr('disabled') === 'disabled';
    }
});

if (!Array.prototype.first) {
    Array.prototype.first = function () {
        return (this.length > 0) ? this[0] : null
    }
}

if (!Array.prototype.last) {
    Array.prototype.last = function () {
        return this[this.length - 1]
    }
}

String.prototype.replaceLast = function (search, replace) {
    return this.replace(new RegExp(search + "([^" + search + "]*)$"), replace + "$1");
}

// #endregion